import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { removeRequestNote } from 'RestAPIs/roster/notes';

const useRemoveRequestNote = ({ isWebSocketEnabled = false }) => {
  const queryClient = useQueryClient();

  return useMutation((noteId: number) => removeRequestNote(noteId), {
    onSuccess: () => {
      !isWebSocketEnabled && queryClient.invalidateQueries('requestNotes');
      showSuccessSnackbar();
    },
    onError: () => {
      showErrorSnackbar();
    }
  });
};

export default useRemoveRequestNote;
